/** Localization resource row from LMS Resources API. */
export interface ResourceDto {
  culture: string;
  /** Display alias for API `name`. */
  labelName: string;
  value: string;
  description: string;
  /** API / path key. */
  name?: string;
}

/**
 * Payload for POST / PUT `/lms/api/Resources` and POST `/bulk`.
 * UI shows “Label Name”; API property is `name` (`Name`).
 */
export interface SaveResourceRequest {
  culture: string;
  name: string;
  value: string;
  description: string;
}

/** Payload for range create — POST `/lms/api/Resources/bulk`. */
export type SaveResourceRangeRequest = SaveResourceRequest[];

export interface ResourceApiResponse<T> {
  data?: T;
  message?: string;
  succeeded?: boolean;
}

/** Prefer `labelName`; fall back to API `name`. */
export function resourceLabelName(item: Pick<ResourceDto, 'labelName' | 'name'>): string {
  return String(item.labelName ?? item.name ?? '').trim();
}

/** GET `/lms/api/Resources` query params. */
export interface ResourceQueryParams {
  search?: string | null;
}
